import { render } from "./reportbin.vue?vue&type=template&id=04549652&scoped=true"
import script from "./reportbin.vue?vue&type=script&lang=js"
export * from "./reportbin.vue?vue&type=script&lang=js"

import "./reportbin.vue?vue&type=style&index=0&id=04549652&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04549652"]])

export default __exports__